import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./../styles/components/Testimonials.css";

export default function TestimonialSection() {
  const reviews = [
    {
      text: "Jai Vishwakarma Enterprises delivered outstanding quality and reliability. Truly professional work!",
      author: "Amit Sharma  ",
    },
    {
      text: "Their planning and execution exceeded my expectations. On time and hassle-free.",
      author: "Ritu Mehra  ",
    },
    {
      text: "A dedicated team that turned my vision into reality with precision and care.",
      author: "Sanjay Verma ",
    },
    {
      text: "Impressed with their innovative ideas and commitment to safety standards.",
      author: "Neha Gupta ",
    },
  ];

  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  // autoplay
  useEffect(() => {
    if (paused) return;

    const firstTimeout = setTimeout(() => {
      setIndex((prev) => (prev + 1) % reviews.length);

      const interval = setInterval(() => {
        setIndex((prev) => (prev + 3) % reviews.length);
      }, 10000);

      return () => clearInterval(interval);
    }, 30000);

    return () => clearTimeout(firstTimeout);
  }, [paused, reviews.length]);

  // animation variants
  const cardVariants = {
    initial: { opacity: 0, y: 40, scale: 0.92 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: -30, scale: 0.96 },
  };

  return (
    <section
      className="testimonial-section"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* HEADER + RATING INLINE LIKE BEHANCE */}
      <div className="testimonial-header-inline">
        <h2>Happy clients feedback</h2>
         <div className="rating-box-inline">
    <span className="rating-score">4.9</span>
    <span className="separator">|</span>
    <span className="stars">⭐ ⭐ ⭐ ⭐ ⭐</span>
    
    <span className="customers">2k+ satisfied customers</span>
  </div>
      </div>

      <p className="subtext">
        Every project is special for us, and your feedback drives us to deliver even better.
      </p>

      <div className="single-review-area">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            className="review-card"
            variants={cardVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{
              type: "spring",
              stiffness: 120,
              damping: 18,
              duration: 0.6,
            }}
            aria-live="polite"
          >
            <span className="quote">“</span>
            <p className="review-text">{reviews[index].text}</p>
            <p className="review-author">{reviews[index].author}</p>
            <div className="quote-badge" aria-hidden="true"></div>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="testimonial-footer">
        <a
          href="https://g.co/kgs/n9bUAXM"
          target="_blank"
          rel="noopener noreferrer"
          className="review-button"
        >
          See What Others Say
        </a>
      </div>
    </section>
  );
}
